module.exports = __webpack_public_path__ + "static/media/Banner2021.dbfdec88.png";